import { Button, Result } from "antd";

export default function PagamentoSucesso() {
    return <Result
        status="success"
        title="Pagamento realizado com sucesso! Uma mensagem de confirmação chegará em seu e-mail em breve."
    />
}